import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import AIReviewedChip from "./AIReviewedChip";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const OpportunitiesSection = ({
  // original prop
  aiOpportunities,

  onOpenOpportunity,
  entityId,
  AiSectionFeedback,

  // NEW (for backend feedback integration)
  requestId,
  uiSectionKey = "ai_recommended_opportunities",
  userEmail,
}) => {
  const list = aiOpportunities;
  const getDotColor = (type) => {
    if (type === "retention") return "#d32f2f"; // red
    return "#15803d"; // green (cross-sell)
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Card
        sx={{
          borderRadius: "0.75rem",
          border: "none",
          boxShadow: "0 12px 30px rgba(15,23,42,0.15)",
          bgcolor: "#ffffff",
          color: "#111827",
        }}
      >
        <CardContent sx={{ p: 3.5 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2.5,
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Tooltip
                    title="AI suggested opportunities based on relationship signals, product fit and market context."
                    arrow
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        fontSize: "1.05rem",
                        color: "#003366",
                        cursor: "help",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      AI Recommended Opportunities
                    </Typography>
                  </Tooltip>
                  <AIReviewedChip mode="light" />
                  <DataSourceIcon
                    mode="light"
                    sources={["Nasdaq", "Web Search"]}
                  />
                </Box>
              </Box>
            </Box>

            <Box
              sx={{ display: "inline-flex", alignItems: "center", gap: 1.25 }}
            >
              <Chip
                label="Suggested next 3–6 months"
                size="small"
                sx={{
                  borderRadius: "999px",
                  fontSize: "0.75rem",
                  bgcolor: "rgba(0,51,102,0.04)",
                  border: "1px solid rgba(0,51,102,0.14)",
                  color: "#003366",
                }}
              />

              <AiSectionFeedback
                sectionName="EntityProfile - AI Recommended Opportunities (AI-reviewed)"
                entityId={entityId}
                variant="light"
                requestId={requestId}
                uiSectionKey={uiSectionKey}
                userEmail={userEmail}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 3,
              mb: 3,
              pl: 0.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  width: 14,
                  height: 14,
                  borderRadius: "50%",
                  bgcolor: "#d32f2f",
                }}
              />
              <Typography sx={{ fontSize: "0.8rem", color: "#1e293b" }}>
                Retention Priorities
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  width: 14,
                  height: 14,
                  borderRadius: "50%",

                  bgcolor: "#15803d",
                }}
              />
              <Typography sx={{ fontSize: "0.8rem", color: "#1e293b" }}>
                Cross sell Opportunities
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "1fr 1fr",
                lg: "1fr 1fr 1fr",
              },
              gap: 2.5,
              mt: 1,
            }}
          >
            {(aiOpportunities || [])?.map((item) => (
              <Box
                key={item.id}
                sx={{
                  borderRadius: "0.85rem",
                  border: "1px solid rgba(15,23,42,0.12)",
                  boxShadow: "0 10px 24px rgba(15,23,42,0.08)",
                  bgcolor: "#ffffff",
                  p: 2.25,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  minHeight: 150,
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-1px)",
                    boxShadow: "0 14px 32px rgba(15,23,42,0.12)",
                  },
                }}
              >
                {/* HEADER: dot + title + info icon */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                  }}
                >
                  {/* Left side */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        bgcolor: getDotColor(item.type),
                      }}
                    />

                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: "#003366",
                        fontSize: "0.9rem",
                        lineHeight: 1.3,
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>

                  {/* Right side */}
                  <Tooltip title="View details" arrow>
                    <IconButton
                      size="small"
                      onClick={() => onOpenOpportunity(item)}
                      sx={{
                        color: "#003366",
                        p: 0.25,
                      }}
                    >
                      <InfoOutlineIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* BODY */}
                <Typography sx={{ fontSize: "0.8rem", color: "#4b5563" }}>
                  {item.rationale}
                </Typography>
              </Box>
            ))}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OpportunitiesSection;
